import {
  DraggableHandler,
  MenuTree,
  useAppSelector,
  useGetUserOrgNodesQuery
} from '@monorepo/shared';
import { selectLoginAccount } from '@monorepo/shared/store/accountSlice';
import {
  selectDebugKey,
  selectPermission
} from '@monorepo/shared/store/authSlice';
import { isExpanded } from '@monorepo/shared/store/sidemenuSlice';
import { Nav, Sidebar, Sidenav } from 'rsuite';
import { HomeElms, server } from '../config/const';
import { CSSProperties, useMemo, useState } from 'react';
// import DashboardIcon from '@rsuite/icons/legacy/Dashboard';
import MagicIcon from '@rsuite/icons/legacy/Magic';
import { useLocation, useNavigate } from 'react-router-dom';
import { selectHaGroups } from '@monorepo/shared/store/groupSlice';

export const Sidemenu = () => {
  const navigate = useNavigate();
  const [width, setWidth] = useState<number>(160);
  const { pathname } = useLocation();
  const debugKey = useAppSelector(selectDebugKey);
  const menuExpanded = useAppSelector(isExpanded);
  const userPermission = useAppSelector(selectPermission);
  const groups = useAppSelector(selectHaGroups);
  const loginAccount = useAppSelector(selectLoginAccount);
  const ou = useGetUserOrgNodesQuery(
    { server: server, fcName: HomeElms?.fcName },
    {
      skip: userPermission === 'unset'
    }
  );

  const draggableHandler = useMemo(
    () => (
      <DraggableHandler
        setWidth={setWidth}
        isRight={false}
        hoverStyle={{ backgroundColor: '#1551d4' }}
      />
    ),
    [setWidth]
  );

  interface IgetIcon {
    name: string;
    active?: boolean;
  }
  const getDashboardIcon = ({ name, active }: IgetIcon) => (
    <div
      style={{
        width: '52px',
        height: '41px',
        marginRight: '12px',
        display: 'grid',
        placeItems: 'center',
        borderRadius: '0 40px 40px 0',
        backgroundColor: active ? '#3ea9ff' : 'unset'
      }}
    >
      <i
        className={`icon-${name}`}
        style={{
          fontSize: '22px'
        }}
      />
    </div>
  );
  return (
    <Sidebar
      // width={menuExpanded ? 560 : 372}
      width={width}
      style={{ position: 'relative', backgroundColor: 'var(--fc-blue)' }}
      collapsible
      className="frame-sidebar"
    >
      {/* {draggableHandler} */}
      <div style={{ height: '100%' }}>
        <Sidenav
          appearance="inverse"
          style={{ height: '100%' }}
          defaultOpenKeys={['2']}
        >
          <div className="nav-title"></div>
          <Sidenav.Body>
            <Nav activeKey="1">
              {Object.values(groups).length > 0 && (
                <Nav.Item
                  eventKey="1"
                  active={pathname.includes('group')}
                  icon={getDashboardIcon({
                    name: 'fortinetone-manageUserGroupIcon',
                    active: pathname.includes('group')
                  })}
                  onClick={() => {
                    navigate('/group/accounts', {
                      state: {
                        debug_key: debugKey
                      }
                    });
                  }}
                >
                  <div>Group</div>
                </Nav.Item>
              )}
              <Nav.Item
                eventKey="2"
                active={pathname.includes('organization')}
                icon={getDashboardIcon({
                  name: 'fortinetone-manageUserIcon',
                  active: pathname.includes('organization')
                })}
                onClick={() => {
                  navigate(`/cred/ou`, {
                    state: {
                      debug_key: debugKey
                    }
                  });
                }}
              >
                <div>Account</div>
              </Nav.Item>
              {/* <Nav.Menu
                eventKey="2"
                active={pathname.includes('organization')}
                title="Organization Units"
                icon={getDashboardIcon({
                  name: 'fontello-globeperson',
                  active: pathname.includes('organization')
                })}
              >
                <div
                  style={{
                    paddingLeft: '52px',
                    paddingRight: '12px',
                    paddingTop: '10px'
                  }}
                >
                  <MenuTree />
                </div>
              </Nav.Menu> */}
            </Nav>
          </Sidenav.Body>
        </Sidenav>
      </div>
    </Sidebar>
  );
};
